var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBatIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.911,
    height: 21.721,
    viewBox: "0 0 25.911 21.721",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_381",
    "data-name": "Path 381",
    d: "M414.678,101.9a1.359,1.359,0,0,0-.518-1.086,2.431,2.431,0,0,0-1.293-.433,2.155,2.155,0,0,0-1.21.434l-4.231,3.547a3.552,3.552,0,0,0-1.724-.433,3.407,3.407,0,0,0-2.247.724L389.293,116.6a1.138,1.138,0,0,0-.517,1.013h0a2.161,2.161,0,0,0,.346,1.159,10,10,0,0,0,1.553,1.737,6.618,6.618,0,0,0,3.453,1.594h0a1.866,1.866,0,0,0,1.21-.441L409.591,109.8a2.327,2.327,0,0,0,.343-3.331l4.23-3.546a1.234,1.234,0,0,0,.518-1.015Zm-12.433,5.286c1.038.8,3.542,2.606,4.663,3.4l1.814-1.521a1.557,1.557,0,0,0,0-2.316l-1.642-1.375a2.361,2.361,0,0,0-1.38-.435,2.193,2.193,0,0,0-1.384.435Zm4.232,3.692c-1.035-.8-3.625-2.605-4.663-3.4l-.6.507c1.122.8,3.624,2.679,4.662,3.4Zm-.95.869-11.049,9.2a.482.482,0,0,1-.346.146h0a4.969,4.969,0,0,1-2.589-1.3c-1.036-.869-1.9-2.027-1.381-2.462l10.7-8.978c1.036.8,3.626,2.607,4.664,3.4Zm7.77-9.557-4.142,3.477-.777-.653,4.145-3.4c.085-.144.172-.144.345-.144a.521.521,0,0,1,.43.144c.087.074.087.146.087.29S413.383,102.126,413.3,102.194Z",
    transform: "translate(-388.773 -100.385)",
    fill: "#707070"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatIcon);
export default __webpack_public_path__ + "static/media/bat-icon.f74253b633182a5ccfec576c26c87f7d.svg";
export { ForwardRef as ReactComponent };